import React, { useEffect, useState } from 'react';
import { contadorSolicitudes, contadorResponder } from '../services/api';

const fdate = (d) => d ? new Date(d).toLocaleDateString('es-CO') : '—';
const EST = {
  aprobado:  { l: 'Aprobado',  c: '#10b981', bg: '#022c22' },
  pendiente: { l: 'Pendiente', c: '#fbbf24', bg: '#422006' },
  rechazado: { l: 'Rechazado', c: '#fca5a5', bg: '#450a0a' },
  revocado:  { l: 'Revocado',  c: '#fca5a5', bg: '#450a0a' },
};

export default function ContadorAcceso() {
  const [lista, setLista] = useState([]);
  const [msg, setMsg] = useState('');

  const cargar = () => contadorSolicitudes().then(r => setLista(r.data)).catch(() => {});
  useEffect(cargar, []);

  const responder = async (s, estado) => {
    const verbo = estado === 'aprobado' ? 'aprobar' : estado === 'revocado' ? 'revocar el acceso de' : 'rechazar';
    if (!window.confirm(`¿Seguro que deseas ${verbo} a ${s.contador} (${s.contador_email})?`)) return;
    try { await contadorResponder(s.id, estado); setMsg('✅ Actualizado'); setTimeout(() => setMsg(''), 3000); cargar(); }
    catch (e) { setMsg('❌ ' + (e.response?.data?.error || 'Error')); }
  };

  return (
    <div>
      <div style={{ marginBottom: 16 }}>
        <h1 style={s.h1}>Mi contador</h1>
        <p style={s.sub}>Autoriza a tu contador para que revise y lleve la contabilidad de tu empresa. Puedes revocar el acceso cuando quieras.</p>
      </div>
      {msg && <div style={{ ...s.msg }}>{msg}</div>}
      <div style={s.card}>
        <table style={s.table}>
          <thead><tr>{['Contador', 'Correo', 'Solicitado', 'Estado', 'Acciones'].map(h => <th key={h} style={s.th}>{h}</th>)}</tr></thead>
          <tbody>
            {lista.length === 0 && <tr><td colSpan={5} style={s.empty}>Ningún contador ha solicitado acceso todavía. Comparte tu NIT con tu contador para que envíe la solicitud.</td></tr>}
            {lista.map(sol => {
              const e = EST[sol.estado] || EST.pendiente;
              return (
                <tr key={sol.id}>
                  <td style={{ ...s.td, color: '#e2e8f0', fontWeight: 600 }}>{sol.contador}</td>
                  <td style={{ ...s.td, color: '#93c5fd' }}>{sol.contador_email}</td>
                  <td style={s.td}>{fdate(sol.solicitado_at)}</td>
                  <td style={s.td}><span style={{ ...s.badge, background: e.bg, color: e.c }}>{e.l}</span></td>
                  <td style={{ ...s.td, whiteSpace: 'nowrap' }}>
                    {sol.estado === 'pendiente' && <>
                      <button style={s.btnOk} onClick={() => responder(sol, 'aprobado')}>Aprobar</button>
                      <button style={s.btnNo} onClick={() => responder(sol, 'rechazado')}>Rechazar</button>
                    </>}
                    {sol.estado === 'aprobado' && <button style={s.btnNo} onClick={() => responder(sol, 'revocado')}>Revocar</button>}
                    {(sol.estado === 'rechazado' || sol.estado === 'revocado') && <button style={s.btnOk} onClick={() => responder(sol, 'aprobado')}>Aprobar</button>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const s = {
  h1: { fontSize: 24, fontWeight: 700, color: '#f1f5f9', margin: '0 0 2px' },
  sub: { color: '#64748b', fontSize: 14, margin: 0 },
  msg: { background: '#0f172a', border: '1px solid #334155', color: '#cbd5e1', padding: '8px 12px', borderRadius: 8, marginBottom: 12, fontSize: 13 },
  card: { background: '#1e293b', border: '1px solid #334155', borderRadius: 12, padding: 16 },
  table: { width: '100%', borderCollapse: 'collapse', fontSize: 13 },
  th: { textAlign: 'left', padding: '8px', color: '#64748b', fontSize: 11, textTransform: 'uppercase', borderBottom: '1px solid #334155' },
  td: { padding: '10px 8px', color: '#cbd5e1', borderBottom: '1px solid #1e293b' },
  empty: { padding: 24, textAlign: 'center', color: '#64748b' },
  badge: { fontSize: 11, borderRadius: 6, padding: '2px 8px', fontWeight: 600 },
  btnOk: { background: '#166534', color: '#86efac', border: '1px solid #16a34a', borderRadius: 6, padding: '5px 12px', fontSize: 12, cursor: 'pointer', marginRight: 6 },
  btnNo: { background: '#450a0a', color: '#fca5a5', border: '1px solid #b91c1c', borderRadius: 6, padding: '5px 12px', fontSize: 12, cursor: 'pointer' },
};
